import { getURLParam } from '../utilities/toolkit'

const campaignParam = getURLParam('utm_campaign')

if (campaignParam === 'referral_program' && Pura.template.name === 'index') {
  const yotpoID =
    Pura.shop_myshopify_url === 'pura-scents.myshopify.com'
      ? 'cj8-FOnxwMMjZQdL7pmAVA'
      : 'e45kBdjZKFQIMFxnms2gNQ'

  const script = document.createElement('script')
  script.src = `https://cdn-widgetsrepository.yotpo.com/v1/loader/${yotpoID}`
  script.type = 'text/javascript'
  script.async = true
  script.crossOrigin = 'anonymous'

  document.head.appendChild(script)
}
